<script lang="ts">
  /**
   * DASHBOARD LAYOUT — The persistent shell for all authenticated pages.
   *
   * Composes: Sidebar + Header + Main Content Area.
   * The main content area shifts left/right when the sidebar collapses.
   *
   * Usage (in page components):
   * <DashboardLayout>
   *   <YourPageContent />
   * </DashboardLayout>
   */
  import Sidebar from './Sidebar.svelte';
  import Header from './Header.svelte';
  import type { Snippet } from 'svelte';

  interface Props { children: Snippet; }
  let { children }: Props = $props();

  let sidebarCollapsed = $state(false);
</script>

<div class="min-h-screen bg-surface-900">
  <Sidebar bind:collapsed={sidebarCollapsed} />
  <Header {sidebarCollapsed} />

  <!-- Main content area — shifts based on sidebar width -->
  <main
    class="pt-16 min-h-screen transition-all duration-300"
    style="margin-left: {sidebarCollapsed ? '4rem' : '16rem'}"
  >
    {@render children()}
  </main>
</div>
